module.exports = __webpack_public_path__ + "media/lose.358ce8c2.ogg";